import "./css/feature_at_a_glance.css";

const FeatureAtAGlance = ({content}) => {
  return <div className="feature_at_a_glance">
    <p>{content}</p>
  </div>
}

export default FeatureAtAGlance